/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_Invite_CodesInputs */

const en_admin_nav_invite_codes = /** @type {(inputs: Admin_Nav_Invite_CodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite Codes`)
};

const zh_admin_nav_invite_codes = /** @type {(inputs: Admin_Nav_Invite_CodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请码`)
};

/**
* | output |
* | --- |
* | "Invite Codes" |
*
* @param {Admin_Nav_Invite_CodesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_nav_invite_codes = /** @type {((inputs?: Admin_Nav_Invite_CodesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_Invite_CodesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_invite_codes(inputs)
	return zh_admin_nav_invite_codes(inputs)
});
export { admin_nav_invite_codes as "admin.nav.invite_codes" }